var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "included-item" }, [
    _vm.iconType == "hotel"
      ? _c("img", {
          staticClass: "included-item__icon",
          attrs: { src: require("./../../img/icons/icon-hotel.svg") }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.iconType == "transfer"
      ? _c("img", {
          staticClass: "included-item__icon",
          attrs: { src: require("./../../img/icons/icon-transfer.svg") }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.iconType == "food"
      ? _c("img", {
          staticClass: "included-item__icon",
          attrs: { src: require("./../../img/icons/icon-food.svg") }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.iconType == "baggage"
      ? _c("img", {
          staticClass: "included-item__icon",
          attrs: { src: require("./../../img/icons/icon-baggage.svg") }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.iconType == "flightclass"
      ? _c("img", {
          staticClass: "included-item__icon",
          attrs: { src: require("./../../img/icons/icon-flightclass.svg") }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.iconType == "handicap"
      ? _c("img", {
          staticClass: "included-item__icon",
          attrs: { src: require("./../../img/icons/icon-handicap.svg") }
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.iconType == "noHandicap"
      ? _c("img", {
          staticClass: "included-item__icon",
          attrs: { src: require("./../../img/icons/icon-handicap.svg") }
        })
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "included-item__content" },
      _vm._l(_vm.textLines, function(text, key) {
        return _c("span", {
          key: key,
          staticClass: "included-item__text",
          domProps: { textContent: _vm._s(text) }
        })
      })
    ),
    _vm._v(" "),
    _c("div", { staticClass: "included-item__actions" }, [
      _vm.translatedTextLines.length
        ? _c(
            "button",
            {
              staticClass: "translate-btn",
              attrs: {
                title: !_vm.showOriginal
                  ? _vm.translations.translations_info_link
                  : _vm.translations.translations_info_link_original
              },
              on: {
                click: function($event) {
                  _vm.showOriginal = !_vm.showOriginal
                }
              }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 32 32"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "m22.69,7.51l-2.33-1.17-.67,1.35,5.51,2.76.59-5.62-1.5-.16-.23,2.21c-1.62-3.09-4.46-5.41-7.87-6.35l-.4,1.45c2.98.82,5.47,2.83,6.9,5.52Z"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "m8.83,25.09l1.36.97.87-1.22-4.51-3.22-.69,5.89,1.49.17.21-1.78c1.74,3.02,4.66,5.24,8.09,6.09l.36-1.46c-3.06-.76-5.65-2.74-7.18-5.44Z"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "m27.71,27.85l.28-1.48c-1.87-.36-3.42-.99-4.65-1.88.56-.59.98-1.19,1.29-1.75.71-1.25.98-2.42,1.09-3.15h2.13v-1.5h-4.89v-2.09h-1.5v2.09h-4.89v1.5h2.13c.11.73.38,1.9,1.09,3.15.31.55.73,1.15,1.29,1.75-1.23.9-2.79,1.53-4.65,1.88l.28,1.48c2.44-.47,4.22-1.34,5.5-2.34,1.28.99,3.06,1.87,5.5,2.34Zm-3.52-8.25c-.11.61-.36,1.51-.91,2.47-.3.52-.66,1-1.07,1.44-.41-.44-.77-.91-1.07-1.44-.55-.95-.8-1.86-.91-2.47h3.96Z"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "m8.14,4.42l-3.93,11.12h1.82l1.11-3.13h4.15l1.15,3.13h1.93l-4.1-11.12h-2.15Zm2.69,6.42h-3.21l.2-.59c.6-1.78,1.09-3.23,1.36-4.13.23.74.64,1.88,1.26,3.61.12.34.25.71.39,1.1Z"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "m12.73,18.46H2.56c-.33,0-.61-.27-.61-.61V2.11c0-.33.27-.61.61-.61h10.18V0H2.56C1.39,0,.44.95.44,2.11v15.74c0,1.16.95,2.11,2.11,2.11h10.18v-1.5Z"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d:
                        "m29.44,12.01h-10.18v1.5h10.18c.33,0,.61.27.61.61v15.74c0,.33-.27.61-.61.61h-10.18v1.5h10.18c1.16,0,2.11-.95,2.11-2.11v-15.74c0-1.16-.95-2.11-2.11-2.11Z"
                    }
                  })
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.roomImages
        ? _c(
            "button",
            {
              staticClass: "translate-btn translate-btn--image-btn",
              attrs: { title: _vm.translations.room_images_button },
              on: {
                click: function($event) {
                  _vm.$emit("showroomimages")
                }
              }
            },
            [
              _c(
                "svg",
                {
                  attrs: {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 31.07 31.07"
                  }
                },
                [
                  _c("path", {
                    staticStyle: { "stroke-width": "0px" },
                    attrs: {
                      d:
                        "M28.87,0H2.21C.99,0,0,.99,0,2.21v26.66c0,1.22.99,2.21,2.21,2.21h26.66c1.22,0,2.21-.99,2.21-2.21V2.21c0-1.22-.99-2.21-2.21-2.21ZM21.71,10.29c-.56,0-1.09.24-1.44.67L6.4,27.08c-.13.15-.19.34-.18.54.02.2.11.38.26.51.3.26.79.22,1.05-.08l13.87-16.12c.16-.19.47-.2.64,0l7.55,8.78v8.16c0,.4-.32.72-.72.72H2.21c-.4,0-.72-.32-.72-.72v-6.69l4.61-5.16c.08-.09.19-.13.31-.13h0c.12,0,.24.05.31.14l3.32,3.72c.27.31.74.33,1.05.06.3-.27.33-.74.06-1.05l-3.32-3.72c-.35-.39-.86-.61-1.42-.61s-1.08.22-1.42.61l-3.5,3.92V2.21c0-.4.32-.72.72-.72h26.66c.4,0,.72.32.72.72v16.23l-6.42-7.46c-.36-.43-.89-.68-1.45-.68Z"
                    }
                  }),
                  _c("path", {
                    staticStyle: { "stroke-width": "0px" },
                    attrs: {
                      d:
                        "M9.89,3.57c-2.22,0-4.03,1.81-4.03,4.03s1.81,4.03,4.03,4.03,4.04-1.81,4.04-4.03-1.81-4.03-4.04-4.03ZM12.44,7.6c0,1.41-1.14,2.55-2.55,2.55s-2.55-1.14-2.55-2.55,1.14-2.55,2.55-2.55,2.55,1.14,2.55,2.55Z"
                    }
                  })
                ]
              )
            ]
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5fc006fd", { render: render, staticRenderFns: staticRenderFns })
  }
}